import { Link, useNavigate } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';

export default function Home() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', textAlign: 'center' }}>
      <div>
        <h1 style={{ fontSize: 48, marginBottom: 20 }}>24/7 Roulette</h1>
        <p style={{ marginBottom: 20 }}>Welcome, {user?.username || "Player"}!</p>
        <Link to="/game" style={{ color: '#ffd21f', fontSize: 24 }}>Play Now</Link>
        <div style={{ marginTop: 28 }}><button style={{ padding: "12px 24px", background: "#641b20", color: "white", border: "1px solid #ffd21f", borderRadius: 8 }} onClick={() => { logout(); navigate("/login", { replace: true }); }}>Logout</button></div>
      </div>
    </div>
  );
}
